import React, { useState } from 'react';
import { computed, makeAutoObservable } from 'mobx';
import { observer } from 'src/utils/mobx-react';
import { AppState, useAppStateContext } from 'src/AppState/AppState';
import { Resource } from 'src_common/common/mobx-utils/Resource';
import { TableauEmbeddedCreateLinkType } from 'src/AppState/sdk/staff';
import { IframeWrapper, InfoWrapper } from 'src/components/TableauDashboards/TableauDashboards.styles';

class TableauDashboardLinkState {
    private readonly link: Resource<TableauEmbeddedCreateLinkType>;

    public constructor(
        private readonly appState: AppState,
        private readonly tableauDashboards: boolean
    ) {
        this.link = new Resource(async (): Promise<TableauEmbeddedCreateLinkType> => {
            const responseLinkResult = await this.appState.sdkStaff.tableauEmbeddedCreateLink(
                this.appState.isProdMode,
                this.appState.reduxBackofficeUserState.tableauAccessLogin
            );

            return responseLinkResult;
        });
        makeAutoObservable(this);
    }

    @computed public get getLink(): LinkRespose {
        if (this.tableauDashboards === false) {
            return {
                status: 'access-denied',
                text: 'Access Denied',
            };
        }
        const data = this.link.get();

        if (data.type === 'ready') {
            if (data.value.link === null || data.value.link === undefined) {
                return {
                    status: 'access-denied',
                    text: 'Access Denied',
                };
            } else {
                return {
                    status: 'link-response',
                    text: data.value.link,
                };
            }
        } else if (data.type === 'error') {
            return {
                status: 'access-denied',
                text: 'Access Denied',
            };
        }

        return {
            status: 'loading',
            text: 'Loading...',
        };
    }
}

interface LinkRespose {
    status: 'error' | 'access-denied' | 'loading' | 'link-response';
    text: string;
}
interface DashboardPropsType {
    workbookView: string;
}

export const TableauDashboard = observer('TableauDashboard', ({ workbookView }: DashboardPropsType) => {
    const appState = useAppStateContext();
    const {
        configState: {
            config: { tableauDashboards },
        },
    } = appState;

    const [state] = useState(() => new TableauDashboardLinkState(appState, tableauDashboards));

    if (state.getLink.status === 'link-response') {
        return (
            <IframeWrapper
                src={`${state.getLink.text}/${workbookView}`}
                width='100%'
                height='100%'
            />
        );
    }

    return <InfoWrapper>{state.getLink.text}</InfoWrapper>;
});
